import { ComponentStoreV2Factory } from '../../../../modules/shared/store/common/component-store-v2.factory';
import { computed, Injectable } from '@angular/core';
import { ServiceTypeGridItemObject } from '@it2go/types';

@Injectable()
export class ServiceTypeDetailPageStore extends ComponentStoreV2Factory {

    public serviceType = computed<ServiceTypeGridItemObject | null>(() => this.data.getServiceTypes()?.items?.[0] || null);

}
